// extracted by mini-css-extract-plugin
module.exports =  {"tc-pagination":"Pagination-module__tc-pagination___PmMoe","page-index":"Pagination-module__page-index___CC5nE"};